import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import AccordionHeaderContent from './AccordionHeaderContent'
import NotStartedStepMessage from './NotStartedStepMessage'
import NoContractStatus from './ContractStatus/NoContractStatus'
import PendingContractStatus from './ContractStatus/PendingContractStatus'
import SignedContractStatus from './ContractStatus/SignedContractStatus'
import RefusedContractStatus from './ContractStatus/RefusedContractStatus'
import CanceledContractStatus from './ContractStatus/CanceledContractStatus'
import IOrder from '@interfaces/IOrder'
import { getStepState } from '../utils/getStepState'

interface AccordionSignatureProps {
  stepProgress: number
  inProgressOrder: IOrder | null
}

const AccordionSignature: React.FC<AccordionSignatureProps> = ({
  stepProgress,
  inProgressOrder
}) => {
  const stepState = getStepState(stepProgress)

  const renderContractStatus = () => {
    if (!inProgressOrder?.clicksign_contract) {
      return <NoContractStatus />
    }

    const {
      status,
      sent_at,
      signed_at,
      refused_at,
      canceled_at,
      signing_url,
      document_url,
      has_patient_signed,
      total_signers,
      signed_count,
      are_all_signed
    } = inProgressOrder.clicksign_contract

    switch (status) {
    case 'pending':
    case 'sent':
      return (
        <PendingContractStatus
          internal_id={inProgressOrder?.internal_id}
          sent_at={sent_at}
          signing_url={signing_url}
          has_patient_signed={has_patient_signed}
          signed_count={signed_count}
          total_signers={total_signers}
          contract_holder={String(inProgressOrder?.contract_holder)}
          full_donor={`${inProgressOrder?.selected_donor?.internal_id}${inProgressOrder?.selected_donor?.nickname ? ` - ${inProgressOrder.selected_donor.nickname}` : ''}`}
        />
      )

    case 'signed':
      return (
        <SignedContractStatus
          signed_at={signed_at}
          document_url={document_url}
          has_patient_signed={has_patient_signed}
          signed_count={signed_count}
          total_signers={total_signers}
          are_all_signed={are_all_signed}
          signing_url={signing_url}
        />
      )

    case 'refused':
      return <RefusedContractStatus refused_at={refused_at} />

    case 'canceled':
      return <CanceledContractStatus canceled_at={canceled_at} />

    default:
      return null
    }
  }

  return (
    <Accordion.Item eventKey="6" className={`${stepState}-state`}>
      <Accordion.Header>
        <AccordionHeaderContent
          stepState={stepState}
          progress={stepProgress}
          title="Assinatura do Contrato"
        />
      </Accordion.Header>

      <Accordion.Body>
        <div className="check-sample p-3">
          {stepProgress < 6 ? (
            <NotStartedStepMessage />
          ) : (
            renderContractStatus()
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionSignature
